import { render, staticRenderFns } from "./RegistroFotograficoView.vue?vue&type=template&id=a4853354&scoped=true"
import script from "./RegistroFotograficoView.vue?vue&type=script&lang=js"
export * from "./RegistroFotograficoView.vue?vue&type=script&lang=js"
import style0 from "./RegistroFotograficoView.vue?vue&type=style&index=0&id=a4853354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4853354",
  null
  
)

export default component.exports